module.exports = __webpack_public_path__ + "img/D0012.308291d6.svg";